import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { COLORS } from '@bcm/constants';

import IconButton from '../../UI/button/IconButton';
import IconMap from '../../UI/icon/IconMap';
import ImageCanvasMenu from '../imageCanvas/ImageCanvasMenu';
import canvasThickness from '../utils/canvasThickness';
import { bodySiteCanvasDims } from './bodySiteCanvasUtils';

const BodySiteCanvasFooter = ({
	canvasClear,
	toggleEraser,
	isEraser,
	selectCanvasThickness,
	undo,
	save,
}) => (
	<View style={styles.container}>
		<IconButton
			onPress={canvasClear}
			icon={IconMap.delete}
			text={'Clear'}
		/>
		<IconButton
			onPress={toggleEraser}
			icon={isEraser ? IconMap.brush : IconMap.eraser}
			text={isEraser ? 'Brush' : 'Eraser'}
		/>
		<ImageCanvasMenu
			onPress={selectCanvasThickness}
			items={canvasThickness}
			icon={IconMap.resize}
			text='Resize'
		/>
		<IconButton
			onPress={undo}
			icon={IconMap.undo}
			text={'Undo'}
		/>
		<IconButton
			onPress={save}
			icon={IconMap.canvasSave}
			text={'Save'}
			color={COLORS.burn.chemical}
		/>
	</View>
);

const styles = StyleSheet.create({
	container: {
		height: bodySiteCanvasDims.footerHeight,
		width: '100%',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
	}
});

export default memo(BodySiteCanvasFooter);